import { SourceQuoteRequestLine } from "../dtos/SourceQuoteRequestLine";
import { NO_OPTIMIZED_MACHINE_TIMES } from "./computeOptimizedMachineTimes";
import { computeProcessesPrice } from "./computeProcessesPrice";

export const computeClusterPrice = (
  sourceQuoteRequestLine: SourceQuoteRequestLine | null,
): number => {
  if (!sourceQuoteRequestLine || !sourceQuoteRequestLine.cluster?.targetQuoteRequestLines) {
    return 0;
  }

  const targetQuoteRequestLines = sourceQuoteRequestLine.cluster.targetQuoteRequestLines;

  const totalProcessStepsPriceSum = targetQuoteRequestLines.reduce(
    (sum: number, quoteRequestLine) => {
      return (
        sum +
        computeProcessesPrice({
          quantity: sourceQuoteRequestLine.quantity,
          reworkRatio: sourceQuoteRequestLine.reworkRatio,
          quantityInAssembly: sourceQuoteRequestLine.part.quantityInAssembly,
          addedValueMarginRatio: sourceQuoteRequestLine.addedValueMarginRatio,
          productsMarginRatio: sourceQuoteRequestLine.productsMarginRatio,
          processSteps: quoteRequestLine.processSteps.filter(
            (processStep) =>
              !sourceQuoteRequestLine.cluster?.excludedProcessSteps
                .map((ps) => ps.id)
                .includes(processStep.id),
          ),
          optimizedMachineTimes: NO_OPTIMIZED_MACHINE_TIMES,
        }).partProcessesCost
      );
    },
    0,
  );

  return totalProcessStepsPriceSum / targetQuoteRequestLines.length;
};
